import React, { useEffect, useState } from 'react';
import { Switch } from 'antd';
import { ButtonGoBack, PageTitle, Row } from '~/components';
import SmarPanelToolsGrid from '../components/smarPanelToolsGrid.component';
import {
  ensureSmarPanelFlagOnVisit,
  setSmarPanelFlag,
} from '../utils/smarPanelStorage';
import * as S from './smarPanelControl.styled';

function SmarPanelControl() {
  const [enabled, setEnabled] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const active = ensureSmarPanelFlagOnVisit();
    setEnabled(active);
    setReady(true);
  }, []);

  function handleToggle(checked) {
    setSmarPanelFlag(checked);
    setEnabled(checked);
  }

  return (
    <>
      <PageTitle titulo="SmarPanel" />
      <S.ControlSection aria-busy={!ready}>
        <S.ToggleRow>
          <Switch
            checked={enabled}
            onChange={handleToggle}
            disabled={!ready}
            aria-labelledby="smarpanel-control-toggle-label"
          />
          <S.ToggleLabel id="smarpanel-control-toggle-label">
            Exibir SmarPanel nas telas
          </S.ToggleLabel>
        </S.ToggleRow>
        <S.StatusHint>
          {ready
            ? enabled
              ? 'SmarPanel está ativo neste navegador, em todos os portais *.smarapd.com.br. Permanece até limpar os cookies.'
              : 'SmarPanel está desativado neste navegador, em todos os portais *.smarapd.com.br.'
            : 'Carregando preferência…'}
        </S.StatusHint>
        {ready ? <SmarPanelToolsGrid /> : null}
      </S.ControlSection>
      <Row>
        <ButtonGoBack />
      </Row>
    </>
  );
}

export default SmarPanelControl;
